import React from "react";
import {
  FormControl,
  Select,
  MenuItem,
  Typography,
  Box,
  SelectChangeEvent,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

interface SelectFieldProps {
  name: string;
  value: string | number;
  onChange: (event: SelectChangeEvent<string | number>) => void;
  options: { label: string; value: number | string }[];
  label?: string;
  placeHolder?: string;
  required?: boolean;
  disabled?: boolean;
  error?: string;
  readOnly?: boolean;
  backgroundColor?: string;
  resettable?: boolean;
}

const CustomSelect: React.FC<SelectFieldProps> = ({
  name,
  value,
  onChange,
  options,
  label,
  placeHolder = "Select",
  required,
  disabled,
  error,
  readOnly,
  backgroundColor,
  resettable = false,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        marginBottom: error ? "0px" : "8px",
      }}
    >
      {label && (
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: "medium",
            fontSize: "12px",
            display: "flex",
            color: "#FFFFFF",
          }}
        >
          {label}{" "}
          {required && (
            <span
              style={{ color: "red", marginLeft: "5px", lineHeight: "1.5" }}
            >
              *
            </span>
          )}
        </Typography>
      )}
      <FormControl fullWidth variant="outlined" error={!!error}>
        <Select
          name={name}
          value={value}
          onChange={onChange}
          displayEmpty
          disabled={disabled}
          readOnly={readOnly}
          IconComponent={readOnly ? () => null : ExpandMoreIcon}
          sx={{
            borderRadius: "0px",
            height: "40px",
            fontSize: "14px",
            backgroundColor: backgroundColor || "#393939",

            "& .MuiSelect-select.Mui-disabled": {
              color: "#CCCCCC",
              borderColor: "#393939 !important",
            },
            "& .MuiOutlinedInput-root.Mui-disabled": {
              "& fieldset": {
                borderColor: "#CCCCCC !important",
              },
            },

            "& .MuiOutlinedInput-input.Mui-disabled": {
              color: "#CCCCCC",

              borderColor: "#393939 !important",
              "-webkit-text-fill-color": "unset !important",
            },
            "& .MuiOutlinedInput-root": {
              borderColor: error ? "#d32f2f!important" : "#808080!important",
              "& fieldset": {
                borderColor: error ? "#d32f2f" : "#808080!important",
              },
            },
            "& input::placeholder": {
              color: "#CCCCCC",

              opacity: 1,
            },
            "&:hover fieldset": {
              borderColor: "#808080 !important",
            },
            "& .MuiSelect-select": {
              padding: "10px",
              color: value ? "#CCCCCC" : "#CCCCCC",
            },
            "& fieldset": {
              borderColor: error ? "#d32f2f !important" : "#808080",
            },
            "& .MuiSvgIcon-root": {
              color: "#CCCCCC",
            },
          }}
        >
          {resettable ? (
            <MenuItem value="">{placeHolder}</MenuItem>
          ) : (
            <MenuItem value="" disabled>
              {placeHolder}
            </MenuItem>
          )}
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {error && (
        <Typography
          className="f-12"
          sx={{
            fontWeight: "medium",
            textAlign: "left",
            color: "#d32f2f",
            paddingTop: "0px",
          }}
        >
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default CustomSelect;
